import { extendTheme } from '@chakra-ui/react'
import { createBreakpoints } from '@chakra-ui/theme-tools'

const fonts = { mono: `'Menlo', monospace` }

const breakpoints = createBreakpoints({
  sm: '40em',
  md: '52em',
  lg: '64em',
  xl: '80em',
})

const theme = extendTheme({ 
  colors: {
    rekening: {
      50: '#f0f9f5',
      100: '#d4ede3',
      200: '#a8dbc7',
      300: '#7cc9ab',
      400: '#50b78f',
      500: '#1a5f3f', // Hauptfarbe
      600: '#154d33',
      700: '#0f3b27',
      800: '#0a291b',
      900: '#05170f',
    },
    bordeaux: {
      50: '#fef2f2',
      100: '#fee2e2',
      200: '#fecaca',
      300: '#fca5a5',
      400: '#f87171',
      500: '#9B2C2C', // Bordeaux-Rot Hauptfarbe
      600: '#7F1D1D',
      700: '#63171B',
      800: '#4C1D1F',
      900: '#3D1A1C',
    }
  },
  fonts: {
    heading: `'Funnel Display', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`,
    body: `'Funnel Display', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`,
    mono: `'Menlo', monospace`,
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: '500',
        borderRadius: 'md',
      },
      variants: {
        solid: (props: any) => ({
          bg: props.colorScheme === 'rekening' ? 'rekening.500' : undefined,
          color: props.colorScheme === 'rekening' ? 'white' : undefined,
          _hover: {
            bg: props.colorScheme === 'rekening' ? 'rekening.600' : undefined,
            _disabled: {
              bg: props.colorScheme === 'rekening' ? 'rekening.300' : undefined,
            }
          },
          _active: {
            bg: props.colorScheme === 'rekening' ? 'rekening.700' : undefined,
          }
        }),
        outline: (props: any) => ({
          borderColor: props.colorScheme === 'rekening' ? 'rekening.500' : undefined,
          color: props.colorScheme === 'rekening' ? 'rekening.700' : undefined,
          _hover: {
            bg: props.colorScheme === 'rekening' ? 'rekening.50' : undefined,
            borderColor: props.colorScheme === 'rekening' ? 'rekening.600' : undefined,
          },
          _active: {
            bg: props.colorScheme === 'rekening' ? 'rekening.100' : undefined,
          }
        }),
        ghost: (props: any) => ({
          color: props.colorScheme === 'rekening' ? 'rekening.700' : undefined,
          _hover: {
            bg: props.colorScheme === 'rekening' ? 'rekening.50' : undefined,
          },
          _active: {
            bg: props.colorScheme === 'rekening' ? 'rekening.100' : undefined,
          }
        })
      },
      defaultProps: {
        colorScheme: 'rekening',
      }
    },
    Input: {
      baseStyle: {
        field: {
          borderRadius: 'md',
          borderColor: 'gray.300',
          _hover: {
            borderColor: 'rekening.400',
          },
          _focus: {
            borderColor: 'rekening.500',
            boxShadow: '0 0 0 1px var(--chakra-colors-rekening-500)',
          }
        }
      }
    },
    Card: {
      baseStyle: {
        container: {
          borderRadius: 'lg',
          boxShadow: 'sm',
          borderWidth: '1px',
          borderColor: 'gray.200',
        }
      }
    },
    Badge: {
      baseStyle: {
        borderRadius: 'full',
        fontWeight: '500',
      }
    },
    Select: {
      baseStyle: {
        field: {
          borderRadius: 'md',
          borderColor: 'gray.300',
          _hover: {
            borderColor: 'rekening.400',
          },
          _focus: {
            borderColor: 'rekening.500',
            boxShadow: '0 0 0 1px var(--chakra-colors-rekening-500)',
          }
        }
      }
    }
  },
  breakpoints,
})

export default theme
